export const linkToOwnProfile = (html: string, id: string) => {
  return html?.replaceAll?.(`/profile/${id}`, '/profile/') || html
}
